
define(
	'Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey'
,   [
			'Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.View'
		,	'Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation.View'
	]
,   function (
			CustomerFeedbackSurveyView
		,	CustomerFeedbackSurveyConfirmationView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			/** GET COMPONENTS */
			var layout = container.getComponent('Layout');
			var environment = container.getComponent('Environment');
			var pageType = container.getComponent('PageType');

			/** GET CONFIGURATION */
			var enableSurveyForm = environment.getConfig('TTCustomerFeedbackSurvey.enableForm');

			if (enableSurveyForm) {

				// Create Customer Feedback Survey Page
				var registrationPage = {
					name: 'customer_feedback_page',
					routes: ['feedback'],
					view: CustomerFeedbackSurveyView,
					options: { container: container },
					defaultTemplate: {
						name: 'tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey.tpl',
						displayName: 'Feedback'
					}
				}
				pageType.registerPageType(registrationPage);

				// Create Customer Feedback Survey Confirmation Page
				var confirmationPage = {
					name: 'customer_feedback_confirmation_page',
					routes: ['feedback-confirmation'],
					view: CustomerFeedbackSurveyConfirmationView,
					options: { container: container },
					defaultTemplate: {
						name: 'tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_confirmation.tpl',
						displayName: 'Feedback Confirmation'
					}
				}
				pageType.registerPageType(confirmationPage);

			}

		}
	};
});
